import React from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { url } from "../../Constant";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthProvider";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../Utils/PermissionFunctions";

const OutboundCustomizedIvr = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [queue, setQueue] = useState([]);
  // const [audioForm, setAudioForm] = useState([]);
  const [layers, setLayers] = useState();
  // const [extensionNumbers, setExtensionNumbers] = useState([]);
  // const [noOfAudios, setNoOfAudios] = useState();
  const [selectedType, setSelectedType] = useState("");
  const [submittedData, setSubmittedData] = useState({
    vpbx_id: auth.vpbx_id,
    no_of_audios: "",
    type: "",
  });

  const [finalData, setFinalData] = useState();
  // const keysToAdd = [
  //   "option1Enable",
  //   "option2Enable",
  //   "option3Enable",
  //   "option4Enable",
  //   "option5Enable",
  //   "option6Enable",
  // ];

  const [mediaArray, setMediaArray] = useState([]);

  // const noOfOptions = [1, 2, 3, 4, 5, 6];
  const [noOfOptions, setNoOfOptions] = useState([]);
  //   const optionValues = ["call", "prompt"];

  // const handleSelect = (e, indexParent, index) => {
  //   // console.log(e)
  //   let array = Array.isArray(e) ? e.map((x) => x.value) : null;
  //   // console.log(array);
  //   // console.log(array.join(", "));

  //   array.join(",");
  //   let temp = [...layers];
  //   temp[indexParent][`option${index + 1}`] =
  //     array === null ? null : array.join(",");
  //   console.log(temp);
  //   setLayers(temp);
  //   // console.log(e);
  //   // let array = Array.isArray(e) ? e.map((x) => x.value) : null;
  //   // console.log(array);
  //   // // array.join(", ");
  //   // let temp = [...layers];
  //   // temp[indexParent][`option${index + 1}`] = array === null ? null : array;
  //   // setLayers(temp);

  //   // setSelectedNumber(array);
  // };

  const [optionValues, setOptionValues] = useState([]);
  // const convertJsonFormat = (inputJson) => {
  //   const outputObject = {};

  //   inputJson.forEach((item) => {
  //     console.log(item)
  //     const {
  //       ivr_flow_id,
  //       layers,
  //       option0,
  //       option1,
  //       option2,
  //       option3,
  //       option4,
  //       option5,
  //     } = item;
  //     const layerKey = layers;

  //     if (!outputObject[layerKey]) {
  //       outputObject[layerKey] = {
  //         ivr_flow_id,
  //         option0,
  //         option1,
  //         option2,
  //         option3,
  //         option4,
  //         option5,
  //       };
  //     }
  //   });

  //   return outputObject;
  // };
  // Convert data to the desired format

  const createIvr = () => {
    setErrorEnable(true);
    setLoader(true);

    // var formData = new FormData();

    // formData.append("vpbx_id", submittedData.vpbx_id);
    // formData.append("no_of_audios", submittedData.no_of_audios);
    // formData.append("type", submittedData.type);
    // for (let i = 0; i < mediaArray.length; i++) {
    //   const key = mediaArray[i];
    //   formData.append(key, submittedData[key]);
    // }

    // const convertedData = convertJsonFormat(layers);

    const convertedDataNew = layers.reduce((acc, item) => {
      const { layers, no_of_option, ...rest } = item;
      const options = {};
      for (let i = 0; i < no_of_option; i++) {
        options[`option${i + 1}`] = item[`option${i + 1}`];
      }
      acc[layers] = { ...rest, ...options };
      return acc;
    }, {});
    // console.log(convertedDataNew);
    // console.log(convertedData);

    const data = {
      vpbx_id: submittedData.vpbx_id,
      // ...convertedData,
      ...convertedDataNew,
      no_of_option: selectedType,
    };
    // console.log(data);
    if (selectedType !== "") {
      let api = "";
      if (auth.role === "2") {
        api = "update-multi-layer-flow";
      } else {
        api = "user-update-multi-layer-flow";
      }

      axios
        .post(url + api, data, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.data.code === 200) {
              setTimeout(() => {
                setLoader(false);
                toast.success("Multi layer added successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
              }, 1000);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (optionValues) {
      setFinalData([...optionValues, ...queue]);
    }
  }, [optionValues, queue]);

  const renderElemets = (val, indexParent) => {
    return Array.from({ length: parseInt(selectedType) }, (_, index) => (
      <>
        {index === 0 && (
          <>
            <div className="uk-width-1-3">
              <label>Press 0</label>
              <select
                className="uk-select"
                aria-label="Select"
                value={layers[indexParent][`option0`]}
                onChange={(e) => {
                  let temp = [...layers];

                  temp[indexParent][`option0`] = e.target.value;
                  setLayers(temp);
                }}
              >
                <option value="">Select no of options</option>
                {finalData?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="uk-width-1-3">
              <label>Press *</label>
              <select
                className="uk-select"
                aria-label="Select"
                value={layers[indexParent][`option*`]}
                onChange={(e) => {
                  let temp = [...layers];
                  temp[indexParent][`option*`] = e.target.value;
                  // console.log(temp)
                  setLayers(temp);
                }}
              >
                <option value="">Select no of options</option>
                {finalData?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="uk-width-1-3">
              <label>Press #</label>
              <select
                className="uk-select"
                aria-label="Select"
                value={layers[indexParent][`option#`]}
                onChange={(e) => {
                  let temp = [...layers];

                  temp[indexParent][`option#`] = e.target.value;
                  setLayers(temp);
                }}
              >
                <option value="">Select no of options</option>
                {finalData?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="uk-width-1-3">
              <label>Auto Route </label>
              <select
                className="uk-select"
                aria-label="Select"
                value={layers[indexParent][`optiont`]}
                onChange={(e) => {
                  let temp = [...layers];

                  temp[indexParent][`optiont`] = e.target.value;
                  setLayers(temp);
                }}
              >
                <option value="">Select no of options</option>
                {finalData?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
        <div className="uk-width-1-3">
          <label>Press {index + 1}</label>
          <select
            className="uk-select"
            aria-label="Select"
            value={layers[indexParent][`option${index + 1}`]}
            onChange={(e) => {
              let temp = [...layers];
              // if (e.target.value === "call") {
              //   temp[indexParent][`option${index + 1}Enable`] = "call";
              // } else {
              // temp[indexParent][`option${index + 1}Enable`] = false;
              // }

              temp[indexParent][`option${index + 1}`] = e.target.value;
              setLayers(temp);
            }}
          >
            <option value="">Select no of options</option>
            {/* {optionValues?.map((item) => (
            <option key={item.value} value={item.value}>
              {item.name}
            </option>
          ))} */}
            {finalData?.map((item) => (
              <option key={item.value} value={item.value}>
                {item.name}
              </option>
            ))}
          </select>

          {/* {layers[indexParent][`option${index + 1}Enable`] === "call" && (
          <div>
            <Select
              isMulti
              name="agents"
              options={extensionNumbers}
              // value={layers[indexParent][`option${index + 1}`].split(",")}
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => handleSelect(e, indexParent, index)}
            />
          </div>
        )} */}
        </div>
      </>
    ));
  };

  const renderLayers = () => {
    return layers?.map((val, index) => (
      <>
        <div key={index + 11} uk-grid="" className="uk-width-1-1">
          <div className="uk-width-1-1 layerdHeading">
            <h5>
              <b>Layer {index + 1}</b>
            </h5>
          </div>
        </div>
        <div uk-grid="" className="uk-width-1-1" key={index}>
          {renderElemets(val, index)}
        </div>
      </>
    ));
  };
  // const handleFile = (e, data) => {
  //   var file = e.target.files[0];

  //   var temp = [...mediaArray];
  //   temp.push(data);

  //   var unique = temp.filter(onlyUnique);
  //   setMediaArray(unique);

  //   setSubmittedData({
  //     ...submittedData,
  //     [data]: file,
  //   });
  // };
  useEffect(() => {
    getNoOflayers();
    // getCallPrompt();
    getQueue();
  }, []);

  const getQueue = () => {
    let data = {
      vpbx_id: auth.vpbx_id,
    };

    let api = "";
    if (auth.role === "2") {
      api = "view-queue";
    } else {
      api = "user-view-queue";
    }

    axios
      .post(url + api, data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            let data = [];
            response.data.data.map((val, index) => {
              return data.push({
                name: val.queue_name,
                value: val.queue_id,
              });
            });
            setQueue(data);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getNoOflayers = () => {
    let api = "";
    if (auth.role === "2") {
      api = "no-of-layers";
    } else {
      api = "user-no-of-layers";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then(
        (response) => {
          // if (response.data.status === true )
          // change your umair
          if (response.data.status === true && response.data.data.length > 0) {
            // const newArray = response.data.data.map((obj) => {
            //   const newObj = { ...obj }; // Create a shallow copy of the original object

            //   // Check conditions for each option and set the corresponding enable key value
            //   for (let i = 0; i < keysToAdd.length; i++) {
            //     const optionKey = `option${i}`;
            //     const enableKey = `${optionKey}Enable`;

            //     // Check if the option is not null or an empty string
            //     if (obj[optionKey] !== null && obj[optionKey] !== "") {
            //       // Check if the option starts with the 'layer' string
            //       newObj[enableKey] = obj[optionKey].startsWith("layer")
            //         ? false
            //         : "call";
            //     } else {
            //       // If the option is null or an empty string, set the enable key value to false
            //       newObj[enableKey] = false;
            //     }
            //   }

            //   return newObj;
            // });

            let populatedArray = [];
            for (let i = 0; i < response.data.data[0].no_of_option; i++) {
              populatedArray.push(i + 1);
            }
            // console.log(populatedArray);
            setNoOfOptions(populatedArray);
            // setLayers(newArray);
            setLayers(response.data.data);
            let data = [];
            response.data.data.map((val, index) => {
              return data.push({
                name: `layer${index + 1}`,
                value: `layer${index + 1}`,
              });
            });
            // console.log(data)
            setOptionValues(data);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  // const getCallPrompt = () => {
  //   axios
  //     .post(
  //       url + "/get-extensions",
  //       {
  //         vpbx_id: auth.vpbx_id,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${auth.token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then(
  //       (response) => {
  //         if (response.data.status === true) {
  //           let optionsForMultiSelect = [];
  //           response.data.data.map((val) => {
  //             optionsForMultiSelect.push({
  //               value: val.id,
  //               label: val.username,
  //             });
  //           });
  //           setExtensionNumbers(optionsForMultiSelect);
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  // };

  // function onlyUnique(value, index, array) {
  //   return array.indexOf(value) === index;
  // }

  // useEffect(() => {
  //   if (selectedType !== "") {
  //     let result = audioForm.filter((val) => {
  //       return val.type === selectedType;
  //     });
  //     if (result.length > 0) {
  //       setSubmittedData({
  //         ...submittedData,
  //         no_of_audios: result[0].no_of_audios,
  //       });
  //       setNoOfAudios(result[0].no_of_audios);
  //     }
  //   }
  // }, [selectedType]);

  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>
            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/outbound-sound-settings", {
                            replace: true,
                          })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                        className="uk-active"
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li>
                    <div className="dashboardWrp">
                      <div className="uk-container">
                        <div className="dashboardTop">
                          <div uk-grid="" className="uk-grid uk-grid-small">
                            <div className="uk-width-2-3">
                              <div className="dashboardIntro">
                                <h3>Customized IVR</h3>
                              </div>
                            </div>
                          </div>

                          <form action="javascript:void(0);">
                            <div className="formCreateMain">
                              <div className="uk-grid uk-grid-small">
                                <div className="uk-width-1-1@m uk-margin-top">
                                  <legend className="uk-legend">
                                    Customized IVR
                                  </legend>
                                </div>
                                <div className="uk-width-1-1@m uk-margin">
                                  <label>No of Options</label>
                                  <select
                                    className="uk-select"
                                    aria-label="Select"
                                    value={selectedType}
                                    onChange={(e) => {
                                      setSelectedType(e.target.value);
                                    }}
                                  >
                                    <option value="">
                                      Select no of options
                                    </option>
                                    {noOfOptions?.map((item) => (
                                      <option key={item} value={item}>
                                        {item}
                                      </option>
                                    ))}
                                  </select>

                                  {errorEnable && selectedType === "" && (
                                    <div>please select type</div>
                                  )}
                                </div>

                                {selectedType !== "" && renderLayers()}

                                {(auth.role === "2" ||
                                  (auth.role === "3" &&
                                    checkIndividualPermission(
                                      "customized-ivr",
                                      "read_and_write"
                                    ))) && (
                                  <div className="uk-width-1-1@m uk-float-right">
                                    <div className="formActionBtn uk-text-right">
                                      <button
                                        className="pinkBtn"
                                        onClick={createIvr}
                                      >
                                        {loader ? (
                                          <div uk-spinner="" className="loader">
                                            Adding
                                          </div>
                                        ) : (
                                          "Update"
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OutboundCustomizedIvr;
